export const PLATFORM_MESSAGE_TYPES = [
  { value: 'marketing', label: 'Marketing' },
  { value: 'platform_flow', label: 'Plateforme flow' },
  { value: 'maintenance', label: 'Maintenance' },
];

export function getPlatformMessageStyle(type) {
  if (type === 'maintenance') {
    return {
      container:
        'bg-gradient-to-r from-amber-100 to-orange-50 dark:from-amber-950/50 dark:to-orange-950/40 border-b-2 border-amber-300/70 dark:border-amber-700/60 text-amber-950 dark:text-amber-100 shadow-sm',
      icon: 'Wrench',
      iconClass: 'text-amber-700 dark:text-amber-300',
      badge: 'Maintenance',
      badgeClass:
        'bg-amber-600/15 text-amber-900 dark:text-amber-100 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wide font-semibold',
    };
  }
  if (type === 'platform_flow') {
    return {
      container:
        'bg-gradient-to-r from-sky-100 to-teal-50 dark:from-sky-950/50 dark:to-teal-950/40 border-b-2 border-sky-300/70 dark:border-sky-700/60 text-sky-950 dark:text-sky-100 shadow-sm',
      icon: 'LayoutGrid',
      iconClass: 'text-sky-700 dark:text-sky-300',
      badge: 'Plateforme flow',
      badgeClass:
        'bg-sky-600/15 text-sky-900 dark:text-sky-100 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wide font-semibold',
    };
  }
  return {
    container:
      'bg-gradient-to-r from-violet-100 via-sky-50 to-indigo-100 dark:from-violet-950/50 dark:via-sky-950/40 dark:to-indigo-950/50 border-b-2 border-violet-300/70 dark:border-violet-700/60 text-foreground shadow-sm',
    icon: 'Megaphone',
    iconClass: 'text-violet-600 dark:text-violet-300',
    badge: 'Promo',
    badgeClass:
      'bg-violet-600/15 text-violet-800 dark:text-violet-200 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wide font-semibold',
  };
}

export function mapPlatformMessageRow(row) {
  if (!row) return null;
  return {
    id: row.id,
    title: row.title,
    body: row.body,
    messageType: row.message_type,
    countryId: row.country_id,
    country: row.country
      ? {
          id: row.country.id,
          countryName: row.country.country_name,
          countryCode: row.country.country_code,
        }
      : null,
    startsAt: row.starts_at,
    endsAt: row.ends_at,
    isActive: row.is_active,
    priority: row.priority ?? 0,
    linkUrl: row.link_url,
    linkLabel: row.link_label,
    createdAt: row.created_at,
    updatedAt: row.updated_at,
  };
}

export function validatePlatformMessageForm(values) {
  const errors = {};
  if (!String(values.title || '').trim()) errors.title = 'Le titre est obligatoire.';
  if (!String(values.body || '').trim()) errors.body = 'Le message est obligatoire.';
  if (!values.messageType) errors.messageType = 'Le type est obligatoire.';
  if (!values.startsAt) errors.startsAt = 'La date de début est obligatoire.';
  if (!values.endsAt) errors.endsAt = 'La date de fin est obligatoire.';
  if (values.startsAt && values.endsAt && new Date(values.endsAt) <= new Date(values.startsAt)) {
    errors.endsAt = 'La date de fin doit être postérieure à la date de début.';
  }
  if (values.linkUrl?.trim() && !/^https?:\/\//i.test(values.linkUrl.trim())) {
    errors.linkUrl = 'L’URL doit commencer par http:// ou https://';
  }
  return errors;
}

/** datetime-local value (YYYY-MM-DDTHH:mm) → ISO */
export function datetimeLocalToIso(localValue) {
  if (!localValue) return null;
  const d = new Date(localValue);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

export function isoToDatetimeLocal(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatMessagePeriod(startsAt, endsAt, locale = 'fr-FR') {
  const fmt = (iso) =>
    new Intl.DateTimeFormat(locale, {
      dateStyle: 'short',
      timeStyle: 'short',
    }).format(new Date(iso));
  return `${fmt(startsAt)} → ${fmt(endsAt)}`;
}

export function isMessageCurrentlyActive(msg, now = new Date()) {
  if (!msg?.isActive) return false;
  const t = now.getTime();
  return t >= new Date(msg.startsAt).getTime() && t <= new Date(msg.endsAt).getTime();
}
